import { useFormState } from 'react-final-form';
import { HpaLegacyCompleteSetupBanner } from './HpaLegacyCompleteSetupBanner';

import { useCanMigrateHpaV2 } from '../../../../../_hooks/useCanMigrateHpaV2';
import { InputPairContainer } from '../../../../../_woop-settings/_components/InputPairContainer';
import { SettingRow } from '../../../../../_woop-settings/_components/layout/SettingRow';
import { SettingsForm } from '../../../../../_woop-settings/_components/layout/SettingsForm';
import { SettingsLayout } from '../../../../../_woop-settings/_components/layout/SettingsLayout';
import { PolicyInput } from '../../../../../_woop-settings/_components/PolicyInput';
import {
  HorizontalRightsizingFormModel,
  WorkloadDetailsFormModel,
} from '../../../_types';
import { RightsizingSettingsV1ValidationSchema } from '../../../_validations/rightsizing-settings-v1-validation.schema';
import { ExplanationTooltip } from '../../ExplanationTooltip';
import { HpaSwitch } from '../../HorizontalRightsizingSettings/HpaSwitch';
import { RffControlsProvider } from '@cast/shared-rff-ui';

import { Typography, Box, Stack } from '@cast/design-system';

export const HpaSettingsLegacyForm = () => {
  const { canMigrateHpaV2 } = useCanMigrateHpaV2();

  const { values, errors } = useFormState<
    WorkloadDetailsFormModel<HorizontalRightsizingFormModel>
  >({
    subscription: { values: true, errors: true },
  });

  return (
    <>
      {canMigrateHpaV2 && <HpaLegacyCompleteSetupBanner />}
      <Stack data-testid="horizontal-rightsizing-settings-legacy">
        <Stack
          direction="row"
          alignItems="center"
          gap={8}
          height={48}
          minHeight={48}
        >
          <HpaSwitch />
          <Typography variant="h6">Horizontal optimization</Typography>
        </Stack>
        <SettingsLayout
          settingsRows={
            <SettingRow
              title="Pod count"
              isSelected
              testId="setting-row-pods"
              description={[
                `Min: ${values.horizontalRightsizing.pods.min}`,
                `Max: ${values.horizontalRightsizing.pods.max}`,
              ]}
              hasError={
                !!(errors as RightsizingSettingsV1ValidationSchema)
                  ?.horizontalRightsizing?.pods
              }
            />
          }
          settingsContent={
            <ExplanationTooltip skipAnnotationsTooltip followCursor>
              <Box>
                <SettingsForm title="Pod count">
                  <InputPairContainer data-testid="basic-behavior-field">
                    <RffControlsProvider
                      namePrefix="horizontalRightsizing.pods"
                      readOnly={!values.horizontalRightsizing.enabled}
                    >
                      <PolicyInput
                        name="min"
                        label="Min"
                        variant="number"
                        size="medium"
                        testId="min-replicas"
                        endAdornment="pods"
                      />

                      <PolicyInput
                        name="max"
                        label="Max"
                        variant="number"
                        size="medium"
                        testId="max-replicas"
                        endAdornment="pods"
                      />
                    </RffControlsProvider>
                  </InputPairContainer>
                </SettingsForm>
              </Box>
            </ExplanationTooltip>
          }
        />
      </Stack>
    </>
  );
};
